import React, { useEffect, useState } from 'react';

// Components
import RichTextRenderer from '../components/richTextRenderer';
import Image from '../components/Image';
import Icons from '../components/icon/Icons';
import Cards from '../components/card/Cards';
import Form from '../components/form';
import InternalExternalLink from '../components/Link';
import InternalExternalLinks from '../components/Link/Links';
import Timeline from '../components/timeline';
import Carousel from '../components/carousel';
import Card from '../components/card';
import CaseStudyCard from '../components/card/CaseStudyCard';
import Testimonial from '../components/testimonial';
import Button from '../components/button';
import Faq from '../components/faq';
import Icon from '../components/icon';
import EmptySpace from '../components/EmptySpace';
import Feature from '../components/feature';
import Cta from '../components/cta';
import Integration from '../components/integration';
import Container from '../components/container';
import SideNavigation from '../components/sideNavigation/SideNavigation';
import SideNavigationItems from '../components/sideNavigation/SideNavigationItems';
import GclidFinder from '../scripts/GclidFinder';
import Campaign from '../scripts/Campaign';

// TODO: Better TS definitions
function ContentModelHandler(children: any) {
  const gclidValue = GclidFinder();
  Campaign();

  if (Array.isArray(children)) {
    return children.map((reference: any, index: number) => {
      switch (reference.sys.contentType.sys.id) {
        case 'integration':
          return <Integration {...reference} key={index} />;
        case 'button':
          return <Button data={reference} key={index} />;
        case 'card':
          return <Card card={reference} key={reference.id} />;
        case 'caseStudyCard':
          return <CaseStudyCard card={reference} key={reference.id} />;
        case 'icon':
          return <Icon {...reference} key={index} />;
        case 'feature':
          return <Feature {...reference} key={index} />;
        case 'carousel': {
          const data: Array<object> | any = Object.values(reference.items)[0];
          // eslint-disable-next-line
          const settings = (({ items, ...o }) => o)(reference);
          return <Carousel data={data} settings={settings} key={index} id={reference.id} />;
        }
        case 'sideNavigation':
          return <SideNavigation {...reference} key={index} />;
        case 'sideNavigationItems':
          return <SideNavigationItems {...reference} key={index} />;
        case 'faq':
          return <Faq {...reference} />;
        case 'image':
          return <Image data={reference} key={index} />;
        case 'richtext':
          return (
            <RichTextRenderer
              text={reference.body}
              extraClasses={reference.extraClasses}
              fontSize={reference.fontSize}
              desktopFontSize={reference.desktopFontSize}
              textStyle={reference.textStyle}
              key={index}
            />
          );
        case 'container':
          return <Container data={reference} key={index} />;
        case 'testimonial':
          return <Testimonial data={reference} key={index} />;
        case 'timeline':
          return <Timeline data={reference} key={index} />;
        case 'link':
          return <InternalExternalLink link={reference} key={index} />;
        case 'emptySpace':
          return <EmptySpace {...reference} key={index} />;
        case 'cta':
          return <Cta data={reference} key={index} />;
        case 'formContainer':
          return <Form data={reference} key={index} gclidInputValue={gclidValue} />;
        case 'iconsContainer':
          return (
            <Icons
              icons={reference.icons}
              columnSpan={reference.columnSpan}
              extraClasses={reference.extraClasses}
              key={index}
            />
          );
        case 'cardsContainer':
          return <Cards data={reference} key={index} />;
        case 'linksContainer':
          return <InternalExternalLinks data={reference} key={index} />;
        default:
          break;
      }
    });
  }
}

export default ContentModelHandler;
